import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M19.31 18.9L22.39 22L21 23.39L17.88 20.32C17.19 20.75 16.37 21 15.5 21C13 21 11 19 11 16.5C11 14 13 12 15.5 12C18 12 20 14 20 16.5C20 17.38 19.75 18.21 19.31 18.9ZM15.5 19C16.88 19 18 17.88 18 16.5C18 15.12 16.88 14 15.5 14C14.12 14 13 15.12 13 16.5C13 17.88 14.12 19 15.5 19ZM21 4V6H3V4H21ZM3 16V14H9V16H3ZM3 11V9H21V11H18.97C17.96 10.37 16.77 10 15.5 10C14.23 10 13.04 10.37 12.03 11H3Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "TextSearch"
);
